import { $, $$ } from 'utils/dom';
import { merge } from 'utils/helper';
import Swiper from 'swiper';
import { Navigation, Scrollbar, Pagination } from 'swiper/modules';
import 'swiper/css';

export default class Swiperslider {
  constructor(target, params) {
    this.target = target;
    this.swiper = null;
    this.container = params.container;
    this.sliderOptions = params.sliderOptions || {};
    this.onReady = params.onReady;
    this.focusableElements =
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled]), details:not([disabled]), summary:not(:disabled)';
  }

  init = () => {
    return new Promise(resolve => {
      this.createSlider();
      return resolve();
    });
  };

  createSlider = () => {
    // configure Swiper to use modules
    Swiper.use([Navigation, Scrollbar, Pagination]);

    const swiperDefaultConfig = {
      scrollbar: {
        el: $('.swiper-scrollbar', this.container),
        hide: false,
        draggable: true,
      },
      navigation: {
        nextEl: $('.swiper-button--next', this.container),
        prevEl: $('.swiper-button--previous', this.container),
      },
      mousewheel: false,
      watchOverflow: true,
      slidesPerView: 'auto',
      watchSlidesProgress: true,
      speed: 400,
      on: {
        init: swiper => {
          this.onReady && this.onReady(swiper);
        },

        afterInit: swiper => {
          swiper.slides.forEach(slide => {
            if (!slide.classList.contains('swiper-slide-active')) {
              const focusableElements = $$(this.focusableElements, slide);
              focusableElements.forEach(element => {
                element.setAttribute('tabindex', -1);
              });
            }
          });
        },

        slideChange: swiper => {
          const focusableElementsInPreviousSlide = $$(
            this.focusableElements,
            swiper.slides[swiper.previousIndex]
          );

          const focusableElementsInActiveSlide = $$(
            this.focusableElements,
            swiper.slides[swiper.activeIndex]
          );

          focusableElementsInPreviousSlide.forEach(element => {
            element.setAttribute('tabindex', -1);
          });

          focusableElementsInActiveSlide.forEach(element => {
            element.removeAttribute('tabindex');
          });
        },

        reachEnd: swiper => {
          swiper.slides.forEach(slide => {
            if (slide.classList.contains('swiper-slide-fully-visible')) {
              const focusableElements = $$(this.focusableElements, slide);
              focusableElements.forEach(element => {
                element.removeAttribute('tabindex');
              });
            }
          });
        },
      },
    };

    const sliderConfig = merge(swiperDefaultConfig, this.sliderOptions);

    this.swiper = new Swiper(this.target, sliderConfig);
  };
}
